import { useEffect } from 'react';
import { FormikProps } from 'formik';

/**
 * Custom hook to revalidate touched form fields when the locale changes
 * This ensures validation error messages are updated to the new language
 *
 * @param formik - The Formik form instance
 * @param locale - The current locale from useIntl()
 */
export const useLocaleFormRevalidation = <T extends Record<string, any>>(formik: FormikProps<T>, locale: string) => {
    useEffect(() => {
        // Only revalidate fields that have been touched by the user
        Object.keys(formik.touched).forEach((field) => {
            if (formik.touched[field as keyof typeof formik.touched]) {
                formik.validateField(field);
            }
        });
    }, [locale]);
};
